// extracted by mini-css-extract-plugin
module.exports = {"w131x29k":"w131x29k","t1hfkbc4":"t1hfkbc4","b1e2i24g":"b1e2i24g","c1w1tl4l":"c1w1tl4l"};